import { c as _c } from "react/compiler-runtime";
import { formatClaimStatus, formatClaimCost, formatEditionSize } from "@/helpers/manifoldDisplayHelpers";
import { useMemesManifoldClaim } from "@/hooks/useManifoldClaim";
import NowMintingStatsItem from "./NowMintingStatsItem";
interface NowMintingStatsGridProps {
  readonly nftId: number;
  readonly floorPrice: string;
}
export default function NowMintingStatsGrid(t0) {
  const $ = _c(22);
  const {
    nftId,
    floorPrice
  } = t0;
  const manifoldClaim = useMemesManifoldClaim(nftId);
  const status = manifoldClaim?.status;
  const isStatusLoading = !manifoldClaim;
  let t1;
  if ($[0] !== manifoldClaim) {
    t1 = manifoldClaim ? formatClaimStatus(manifoldClaim) : undefined;
    $[0] = manifoldClaim;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const statusLabel = t1;
  const statusTone = manifoldClaim?.isFinalized ? "ended" : status;
  let t2;
  if ($[2] !== manifoldClaim) {
    t2 = manifoldClaim ? formatEditionSize(manifoldClaim) : undefined;
    $[2] = manifoldClaim;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const editionSize = t2;
  let t3;
  if ($[4] !== manifoldClaim) {
    t3 = manifoldClaim ? formatClaimCost(manifoldClaim) : undefined;
    $[4] = manifoldClaim;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const mintPrice = t3;
  let t4;
  if ($[6] !== editionSize) {
    t4 = <NowMintingStatsItem label="Edition" value={editionSize} />;
    $[6] = editionSize;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isStatusLoading || $[9] !== statusLabel || $[10] !== statusTone) {
    t5 = <NowMintingStatsItem label="Status" value={statusLabel} status={statusTone} isLoading={isStatusLoading} />;
    $[8] = isStatusLoading;
    $[9] = statusLabel;
    $[10] = statusTone;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== isStatusLoading || $[13] !== mintPrice) {
    t6 = <NowMintingStatsItem label="Mint price" value={mintPrice} isLoading={isStatusLoading} />;
    $[12] = isStatusLoading;
    $[13] = mintPrice;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== floorPrice) {
    t7 = <NowMintingStatsItem label="Floor" value={floorPrice} />;
    $[15] = floorPrice;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t8 = <div className="tw-grid tw-grid-cols-2 tw-gap-x-8 tw-gap-y-4 tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-800 tw-pt-5">{t4}{t5}{t6}{t7}</div>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}